import './ColorPicker.scss';
import Control from "../../Control";
import Delegate from "../../Delegate";


export default class ColorPicker extends Control {

	EvColorChanged: Delegate;
	private _FloatingLabel: string;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._FloatingLabel = ''
		this.EvColorChanged = new Delegate();
		super._initFields(settings);
	}

	_render()
	{
		super.np_render(`<div>
<input class="color_panel__native-input" type="color"/> 
${this._FloatingLabel}
</div>`);

		this._root.addEventListener('change', e =>
		{
			this._Value = (e.target as HTMLInputElement).value
			this.EvColorChanged.fire(this, {Color: this._Value})
		});
	}

	setValue(value: string)
	{
		this._Value = value;
		(this._root as HTMLInputElement).value = value;
		this._root.setAttribute('value', value);
	}
}